import './index.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { TableContext } from './context.js';
import { c as cellStyles } from './cell-Dr-jPjDU.js';
import { s as styles } from './table-CLlr1zNv.js';

const TableRowComponent = ({ style, styleHighlighted, action, showAction, animated, onClick, panel, showPanel, children, measure, align, 'data-qa': dataQa = 'table-row', ...rest }, ref) => {
    const { paddingLeft, paddingRight } = useContext(TableContext);
    const highlightedColor = styleHighlighted || style;
    const wasPanelShown = useRef(null);
    const rowRef = useRef(null);
    const multiRef = useMultipleRefs(ref, rowRef);
    useEffect(() => {
        if (wasPanelShown.current === null) {
            wasPanelShown.current = !!(panel && showPanel);
            return;
        }
        if (wasPanelShown.current !== !!(panel && showPanel)) {
            wasPanelShown.current = !!(panel && showPanel);
            rowRef.current && measure?.(rowRef.current);
        }
    }, [panel, showPanel, measure]);
    return (jsxs(Fragment, { children: [jsxs("tr", { ...rest, className: classnames(styles.row, {
                    [styles.active]: !!onClick,
                    [styles.animated]: animated,
                    [styles.withPanel]: showPanel && panel,
                    [styles[`style-${style}`]]: style,
                    [styles[`style-highlighted-${highlightedColor}`]]: highlightedColor,
                }), onClick: onClick, ref: multiRef, "data-qa": dataQa, style: {
                    textAlign: align,
                }, children: [!!paddingLeft && (jsx("td", { className: classnames(cellStyles.spaceCell, cellStyles.pinned, styles.td), "data-qa": "table-row-left-space", style: { width: paddingLeft }, children: showAction && action && jsx("div", { className: cellStyles.control, children: action }) })), children, !!paddingRight && (jsx("td", { className: classnames(cellStyles.spaceCell, styles.td), "data-qa": "table-row-right-space", style: { width: paddingRight } }))] }), panel && showPanel && (jsxs("tr", { "data-qa": `${dataQa}-panel`, "data-magritte-table-row-panel": true, className: classnames(styles.row, styles.rowPanel, styles.animated), style: {
                    textAlign: align,
                }, children: [!!paddingLeft && (jsx("td", { className: classnames(cellStyles.spaceCell, cellStyles.pinned, styles.td), "data-qa": "table-row-left-space", style: { width: paddingLeft } })), panel, !!paddingRight && (jsx("td", { className: classnames(cellStyles.spaceCell, styles.td), "data-qa": "table-row-right-space", style: { width: paddingRight } }))] }))] }));
};
const TableRow = forwardRef(TableRowComponent);

export { TableRow };
//# sourceMappingURL=TableRow.js.map
